import { differenceInCalendarDays } from 'date-fns'

import { type Thread } from './Thread'

export type ThreadGroup = {
  label: 'Today' | 'Yesterday' | 'Previous 7 days' | 'Older'
  threads: Thread[]
}

function labelFor(updatedAt: string, now: Date): ThreadGroup['label'] {
  const date = new Date(updatedAt)

  if (Number.isNaN(date.getTime())) return 'Older'

  const days = differenceInCalendarDays(now, date)

  if (days <= 0) return 'Today'
  if (days === 1) return 'Yesterday'
  if (days < 7) return 'Previous 7 days'
  return 'Older'
}

/**
 * The list comes newest first, so the groups do too. Days are the user's own
 * calendar days, not 24-hour spans: a thread from 23:50 is "Yesterday" at 00:10.
 */
export function groupThreadsByDay(
  threads: readonly Thread[],
  now: Date = new Date()
): ThreadGroup[] {
  const groups: ThreadGroup[] = []

  for (const thread of threads) {
    const label = labelFor(thread.updatedAt, now)
    const last = groups[groups.length - 1]

    if (last?.label === label) {
      last.threads.push(thread)
    } else {
      groups.push({ label, threads: [thread] })
    }
  }

  return groups
}
